import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { TrendingUp, TrendingDown, DollarSign, PieChart, Globe, Briefcase } from 'lucide-react'
import { useFinancasStore } from '@/stores/financas.store'
import { formatCurrency } from '@/lib/utils'

export function FinancasPainel() {
  const { saldoSeparado } = useFinancasStore()

  // Mock data para demonstração
  const financialData = {
    saldoTotal: 45250.75,
    entradas: 12500.00,
    saidas: 8750.25,
    estimativaProximoMes: 15000.00
  }

  return (
    <div className="space-y-6">
      {/* Cards de resumo financeiro */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-5">
        <Card className="border-l-4 border-l-green-500 bg-card dark:bg-card border-border dark:border-border">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-card-foreground dark:text-card-foreground">Saldo Igreja</CardTitle>
            <DollarSign className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600 dark:text-green-400">
              {formatCurrency(saldoSeparado.igreja.saldo)}
            </div>
            <p className="text-xs text-muted-foreground">
              Saldo disponível para operações da igreja
            </p>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-purple-500 bg-card dark:bg-card border-border dark:border-border">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-card-foreground dark:text-card-foreground">Saldo Missões</CardTitle>
            <Globe className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-purple-600 dark:text-purple-400">
              {formatCurrency(saldoSeparado.missoes.saldo)}
            </div>
            <p className="text-xs text-muted-foreground">
              Saldo destinado exclusivamente para missões
            </p>
          </CardContent>
        </Card>

        <Card className="border-l-4 border-l-blue-500 bg-card dark:bg-card border-border dark:border-border">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-card-foreground dark:text-card-foreground">Saldo Total</CardTitle>
            <Briefcase className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-blue-600 dark:text-blue-400">
              {formatCurrency(saldoSeparado.igreja.saldo + saldoSeparado.missoes.saldo)}
            </div>
            <p className="text-xs text-muted-foreground">
              Soma de todos os saldos disponíveis
            </p>
          </CardContent>
        </Card>

        <Card className="bg-card dark:bg-card border-border dark:border-border">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-card-foreground dark:text-card-foreground">Entradas</CardTitle>
            <TrendingUp className="h-4 w-4 text-green-600 dark:text-green-400" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-green-600 dark:text-green-400">
              {formatCurrency(financialData.entradas)}
            </div>
            <p className="text-xs text-muted-foreground">
              Este mês
            </p>
          </CardContent>
        </Card>

        <Card className="bg-card dark:bg-card border-border dark:border-border">
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium text-card-foreground dark:text-card-foreground">Saídas</CardTitle>
            <TrendingDown className="h-4 w-4 text-red-600 dark:text-red-400" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-red-600 dark:text-red-400">
              {formatCurrency(financialData.saidas)}
            </div>
            <p className="text-xs text-muted-foreground">
              Este mês
            </p>
          </CardContent>
        </Card>
      </div>

      {/* Resumo por categoria */}
      <Card className="bg-card dark:bg-card border-border dark:border-border">
        <CardHeader>
          <CardTitle className="text-card-foreground dark:text-card-foreground">Resumo por Categoria</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span className="text-card-foreground dark:text-card-foreground">Dízimos</span>
              <span className="font-medium text-green-600 dark:text-green-400">R$ 8.500,00</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-card-foreground dark:text-card-foreground">Ofertas</span>
              <span className="font-medium text-green-600 dark:text-green-400">R$ 2.800,00</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-card-foreground dark:text-card-foreground">Doações</span>
              <span className="font-medium text-green-600 dark:text-green-400">R$ 1.200,00</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-card-foreground dark:text-card-foreground">Despesas Operacionais</span>
              <span className="font-medium text-red-600 dark:text-red-400">R$ -4.500,00</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-card-foreground dark:text-card-foreground">Ministérios</span>
              <span className="font-medium text-red-600 dark:text-red-400">R$ -2.800,00</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-card-foreground dark:text-card-foreground">Eventos</span>
              <span className="font-medium text-red-600 dark:text-red-400">R$ -1.450,25</span>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Gráficos */}
      <div className="grid gap-4 md:grid-cols-2">
        <Card className="bg-card dark:bg-card border-border dark:border-border">
          <CardHeader>
            <CardTitle className="text-card-foreground dark:text-card-foreground">Entradas vs Saídas</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="h-[200px] flex items-center justify-center text-muted-foreground">
              <div className="text-center">
                <PieChart className="h-12 w-12 mx-auto mb-2" />
                <p>Gráfico de Entradas vs Saídas</p>
                <p className="text-sm">(Implementar com biblioteca de gráficos)</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-card dark:bg-card border-border dark:border-border">
          <CardHeader>
            <CardTitle className="text-card-foreground dark:text-card-foreground">Evolução Mensal</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="h-[200px] flex items-center justify-center text-muted-foreground">
              <div className="text-center">
                <TrendingUp className="h-12 w-12 mx-auto mb-2" />
                <p>Gráfico de Evolução Mensal</p>
                <p className="text-sm">(Implementar com biblioteca de gráficos)</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  )
}